/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Load_Tasks_Failed_ToastInputs */

const en_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load assigned tasks`)
};

const fr_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec du chargement des taches assignees`)
};

const de_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesene Aufgaben konnten nicht geladen werden.`)
};

const it_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare le attivita assegnate`)
};

const ru_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить назначенные задачи.`)
};

const es_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las tareas asignadas`)
};

const zh_cn2_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载分配的任务失败`)
};

const ja_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当てられたタスクの読み込みに失敗しました`)
};

const hi_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सौंपे गए कार्य लोड करने में विफल`)
};

const pt_pt2_explorer_nav_load_tasks_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Tasks_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar tarefas atribuidas`)
};

/**
* | output |
* | --- |
* | "Failed to load assigned tasks" |
*
* @param {Explorer_Nav_Load_Tasks_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_load_tasks_failed_toast = /** @type {((inputs?: Explorer_Nav_Load_Tasks_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Load_Tasks_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "de") return de_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "it") return it_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "es") return es_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_load_tasks_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_load_tasks_failed_toast(inputs)
	return en_explorer_nav_load_tasks_failed_toast(inputs)
});